<template>
    <div>
        <compWrapper title="基础信息" theme="primary">
			<compFormQuery v-if="type=='query'" ref="accountform" class="margin-top-15 margin-layout width-50per" :formdata="getBase" :value="formData" :col="1" :labelWidth="120"></compFormQuery>
            <compFormEdit v-else ref="accountform" class="margin-top-15 margin-layout width-50per" :formdata="getBase" v-model="formData" :col="1" :labelWidth="120"></compFormEdit>
		</compWrapper>
        <div class="text-right" v-if="type!='query'">
            <Button type="primary" @click="submit">确定</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
        <compWrapper v-if="type=='query'" :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="primary">
			<compLog :data="logList" ></compLog>
		</compWrapper>
    </div>
</template>

<script>
import { HttpQueryBillNewsOne,HttpSaveBillNewsOne } from '@/service/costbilling';
import { mapGetters } from 'vuex';
export default {
    props:['querytype','activeid'],
    components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compFormEdit: () => import('@components/templates/formedit'),
		compLog: () => import("@components/templates/log"),
	},
    data(){
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            formData:{},
            logList:[],
        }
    },
    created(){
        if(this.type=='add') return

        this.getDetail()
    },
    computed:{
        ...mapGetters('dictionary', ['getCarrierServiceList','getAlllogProCodeList']),
        getBase(){
            return [
                {
					label: this.$t('fbb.alloment.carrier_server',{defaultValue:'物流产品服务'}),
					key: "carrierGroupId",
                    tag: 'Select',
                    options: this.getAlllogProCodeList.map(item=>{
                        return {
                            value: item.value,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    on:{
                        'on-change':(val)=>{
                            this.changeCarrier(val)
                        }
                    }
				},
                {
					label: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
					key: "carrier",
                    tag: 'div',
                    children:(h)=>{
                        return <div>{this.formData.carrier}</div>
                    }
                
				},
                {
					label: '账户',
					key: "account",
                    tag: 'Input',
				},
                {
					label: '登录名',
					key: "userName",
                    tag: 'Input',
				},
                {
					label: '密码',
					key: "password",
                    tag: 'Input',
                    show:this.type!='query'
				},
                {
                    label: "状态",
                    key: 'active',
                    tag: 'vSelect',
                    options: [
                        {value:0,label:'启用'},
                        {value:1,label:'禁用'}
                    ],
                },
                {
                    label: "是否自动获取账单",
                    key: 'autoBill',
                    tag: 'vSelect',
                    options: [
                        {value:1,label:'是'},
                        {value:0,label:'否'}
                    ],
                },
                {
					label: '备注',
					key: "remark",
                    tag: 'Input',
                    required:false
				},
            ]
        }
    },
    methods:{
        changeCarrier(val){
            let carrierone = this.getAlllogProCodeList.filter(item=>{
                return item.value == val
            })
            this.formData.carrier = carrierone[0].attach.carrierCode
        },
        getDetail(){
            HttpQueryBillNewsOne({
                id:this.id,
            }).then(res=>{
                this.formData = res.data;
                this.formData.password = '';
                this.logList = res.data.orderLogList;
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        submit(){
            HttpSaveBillNewsOne({
                ...this.formData,
            }).then(res=>{
                this.$Message.success(res.message);
                this.cancel()
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$router.push({
                name: 'costbillingBillNewsList',
            });
        }
    }
}
</script>